import { CardStack } from '../card-stack';
import { Orientation } from '../../../../enum/dto/orientation.enum';
import type { PaperSize } from '../../../../shared/paper-size';

export abstract class ThreeByFourCardStack extends CardStack {
  getCardHeightInInches(): number {
    return 3;
  }

  getCardWidthInInches(): number {
    return 4;
  }

  nCardsPerPage(paperSize: PaperSize, isOnPerforatedPaper: boolean): number {
    return 4;
  }

  nColumns(): number {
    return 2;
  }

  nRows(): number {
    return 2;
  }

  cardOrientationOnPortraitPage(): Orientation {
    return Orientation.Portrait;
  }
}
